import { render, staticRenderFns } from "./FooterComponentAbaooe.vue?vue&type=template&id=04232880"
import script from "./FooterComponentAbaooe.vue?vue&type=script&lang=ts"
export * from "./FooterComponentAbaooe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports